module.exports = __webpack_public_path__ + "static/media/therapAreas.6249e5d0.svg";